'use client';

import React from 'react';
import {
    AcademicCapIcon as OutlineAcademicCapIcon,
    ArrowDownTrayIcon as OutlineArrowDownTrayIcon,
    ArrowLeftIcon as OutlineArrowLeftIcon,
    ArrowPathIcon as OutlineArrowPathIcon,
    ArrowRightIcon as OutlineArrowRightIcon,
    ArrowTrendingDownIcon as OutlineArrowTrendingDownIcon,
    ArrowTrendingUpIcon as OutlineArrowTrendingUpIcon,
    BanknotesIcon as OutlineBanknotesIcon,
    Bars3Icon as OutlineBars3Icon,
    BeakerIcon as OutlineBeakerIcon,
    BriefcaseIcon as OutlineBriefcaseIcon,
    CalculatorIcon as OutlineCalculatorIcon,
    CalendarIcon as OutlineCalendarIcon,
    ChartBarIcon as OutlineChartBarIcon,
    ChatBubbleLeftEllipsisIcon as OutlineChatBubbleLeftEllipsisIcon,
    ChatBubbleLeftRightIcon as OutlineChatBubbleLeftRightIcon,
    CheckBadgeIcon as OutlineCheckBadgeIcon,
    CheckCircleIcon as OutlineCheckCircleIcon,
    CheckIcon as OutlineCheckIcon,
    ChevronDownIcon as OutlineChevronDownIcon,
    ChevronRightIcon as OutlineChevronRightIcon,
    ChevronUpIcon as OutlineChevronUpIcon,
    ClockIcon as OutlineClockIcon,
    CodeBracketIcon as OutlineCodeBracketIcon,
    Cog6ToothIcon as OutlineCog6ToothIcon,
    CpuChipIcon as OutlineCpuChipIcon,
    CurrencyDollarIcon as OutlineCurrencyDollarIcon,
    DocumentCheckIcon as OutlineDocumentCheckIcon,
    DocumentTextIcon as OutlineDocumentTextIcon,
    EnvelopeIcon as OutlineEnvelopeIcon,
    ExclamationCircleIcon as OutlineExclamationCircleIcon,
    ExclamationTriangleIcon as OutlineExclamationTriangleIcon,
    EyeIcon as OutlineEyeIcon,
    EyeSlashIcon as OutlineEyeSlashIcon,
    GlobeAltIcon as OutlineGlobeAltIcon,
    HandRaisedIcon as OutlineHandRaisedIcon,
    HomeIcon as OutlineHomeIcon,
    InboxIcon as OutlineInboxIcon,
    InboxStackIcon as OutlineInboxStackIcon,
    InformationCircleIcon as OutlineInformationCircleIcon,
    LightBulbIcon as OutlineLightBulbIcon,
    LockClosedIcon as OutlineLockClosedIcon,
    MapPinIcon as OutlineMapPinIcon,
    NewspaperIcon as OutlineNewspaperIcon,
    PaperAirplaneIcon as OutlinePaperAirplaneIcon,
    PhoneIcon as OutlinePhoneIcon,
    PlayIcon as OutlinePlayIcon,
    PlusCircleIcon as OutlinePlusCircleIcon,
    PresentationChartLineIcon as OutlinePresentationChartLineIcon,
    PuzzlePieceIcon as OutlinePuzzlePieceIcon,
    QuestionMarkCircleIcon,
    RocketLaunchIcon as OutlineRocketLaunchIcon,
    ServerIcon as OutlineServerIcon,
    ShieldCheckIcon as OutlineShieldCheckIcon,
    SparklesIcon as OutlineSparklesIcon,
    StarIcon as OutlineStarIcon,
    TrophyIcon as OutlineTrophyIcon,
    UserCircleIcon as OutlineUserCircleIcon,
    UserGroupIcon as OutlineUserGroupIcon,
    UserIcon as OutlineUserIcon,
    UsersIcon as OutlineUsersIcon,
    WrenchScrewdriverIcon as OutlineWrenchScrewdriverIcon,
    XCircleIcon as OutlineXCircleIcon,
    XMarkIcon as OutlineXMarkIcon,
} from '@heroicons/react/24/outline';
import {
    AcademicCapIcon as SolidAcademicCapIcon,
    ArrowDownTrayIcon as SolidArrowDownTrayIcon,
    ArrowLeftIcon as SolidArrowLeftIcon,
    ArrowPathIcon as SolidArrowPathIcon,
    ArrowRightIcon as SolidArrowRightIcon,
    ArrowTrendingDownIcon as SolidArrowTrendingDownIcon,
    ArrowTrendingUpIcon as SolidArrowTrendingUpIcon,
    BanknotesIcon as SolidBanknotesIcon,
    Bars3Icon as SolidBars3Icon,
    BeakerIcon as SolidBeakerIcon,
    BriefcaseIcon as SolidBriefcaseIcon,
    CalculatorIcon as SolidCalculatorIcon,
    CalendarIcon as SolidCalendarIcon,
    ChartBarIcon as SolidChartBarIcon,
    ChatBubbleLeftEllipsisIcon as SolidChatBubbleLeftEllipsisIcon,
    ChatBubbleLeftRightIcon as SolidChatBubbleLeftRightIcon,
    CheckBadgeIcon as SolidCheckBadgeIcon,
    CheckCircleIcon as SolidCheckCircleIcon,
    CheckIcon as SolidCheckIcon,
    ChevronDownIcon as SolidChevronDownIcon,
    ChevronRightIcon as SolidChevronRightIcon,
    ChevronUpIcon as SolidChevronUpIcon,
    ClockIcon as SolidClockIcon,
    CodeBracketIcon as SolidCodeBracketIcon,
    Cog6ToothIcon as SolidCog6ToothIcon,
    CpuChipIcon as SolidCpuChipIcon,
    CurrencyDollarIcon as SolidCurrencyDollarIcon,
    DocumentCheckIcon as SolidDocumentCheckIcon,
    DocumentTextIcon as SolidDocumentTextIcon,
    EnvelopeIcon as SolidEnvelopeIcon,
    ExclamationCircleIcon as SolidExclamationCircleIcon,
    ExclamationTriangleIcon as SolidExclamationTriangleIcon,
    EyeIcon as SolidEyeIcon,
    EyeSlashIcon as SolidEyeSlashIcon,
    GlobeAltIcon as SolidGlobeAltIcon,
    HandRaisedIcon as SolidHandRaisedIcon,
    HomeIcon as SolidHomeIcon,
    InboxIcon as SolidInboxIcon,
    InboxStackIcon as SolidInboxStackIcon,
    InformationCircleIcon as SolidInformationCircleIcon,
    LightBulbIcon as SolidLightBulbIcon,
    LockClosedIcon as SolidLockClosedIcon,
    MapPinIcon as SolidMapPinIcon,
    NewspaperIcon as SolidNewspaperIcon,
    PaperAirplaneIcon as SolidPaperAirplaneIcon,
    PhoneIcon as SolidPhoneIcon,
    PlayIcon as SolidPlayIcon,
    PlusCircleIcon as SolidPlusCircleIcon,
    PresentationChartLineIcon as SolidPresentationChartLineIcon,
    PuzzlePieceIcon as SolidPuzzlePieceIcon,
    RocketLaunchIcon as SolidRocketLaunchIcon,
    ServerIcon as SolidServerIcon,
    ShieldCheckIcon as SolidShieldCheckIcon,
    SparklesIcon as SolidSparklesIcon,
    StarIcon as SolidStarIcon,
    TrophyIcon as SolidTrophyIcon,
    UserCircleIcon as SolidUserCircleIcon,
    UserGroupIcon as SolidUserGroupIcon,
    UserIcon as SolidUserIcon,
    UsersIcon as SolidUsersIcon,
    WrenchScrewdriverIcon as SolidWrenchScrewdriverIcon,
    XCircleIcon as SolidXCircleIcon,
    XMarkIcon as SolidXMarkIcon,
} from '@heroicons/react/24/solid';

type IconVariant = 'outline' | 'solid';
type HeroIcon = React.ForwardRefExoticComponent<
    Omit<React.SVGProps<SVGSVGElement>, 'ref'> & {
        title?: string;
        titleId?: string;
    } & React.RefAttributes<SVGSVGElement>
>;

interface IconProps {
    name: string;
    variant?: IconVariant;
    size?: number;
    className?: string;
    onClick?: () => void;
    disabled?: boolean;
    [key: string]: any;
}

const outlineIcons: Record<string, HeroIcon> = {
    AcademicCapIcon: OutlineAcademicCapIcon,
    ArrowDownTrayIcon: OutlineArrowDownTrayIcon,
    ArrowLeftIcon: OutlineArrowLeftIcon,
    ArrowPathIcon: OutlineArrowPathIcon,
    ArrowRightIcon: OutlineArrowRightIcon,
    ArrowTrendingDownIcon: OutlineArrowTrendingDownIcon,
    ArrowTrendingUpIcon: OutlineArrowTrendingUpIcon,
    BanknotesIcon: OutlineBanknotesIcon,
    Bars3Icon: OutlineBars3Icon,
    BeakerIcon: OutlineBeakerIcon,
    BriefcaseIcon: OutlineBriefcaseIcon,
    CalculatorIcon: OutlineCalculatorIcon,
    CalendarIcon: OutlineCalendarIcon,
    ChartBarIcon: OutlineChartBarIcon,
    ChatBubbleLeftEllipsisIcon: OutlineChatBubbleLeftEllipsisIcon,
    ChatBubbleLeftRightIcon: OutlineChatBubbleLeftRightIcon,
    CheckBadgeIcon: OutlineCheckBadgeIcon,
    CheckCircleIcon: OutlineCheckCircleIcon,
    CheckIcon: OutlineCheckIcon,
    ChevronDownIcon: OutlineChevronDownIcon,
    ChevronRightIcon: OutlineChevronRightIcon,
    ChevronUpIcon: OutlineChevronUpIcon,
    ClockIcon: OutlineClockIcon,
    CodeBracketIcon: OutlineCodeBracketIcon,
    Cog6ToothIcon: OutlineCog6ToothIcon,
    CpuChipIcon: OutlineCpuChipIcon,
    CurrencyDollarIcon: OutlineCurrencyDollarIcon,
    DocumentCheckIcon: OutlineDocumentCheckIcon,
    DocumentTextIcon: OutlineDocumentTextIcon,
    EnvelopeIcon: OutlineEnvelopeIcon,
    ExclamationCircleIcon: OutlineExclamationCircleIcon,
    ExclamationTriangleIcon: OutlineExclamationTriangleIcon,
    EyeIcon: OutlineEyeIcon,
    EyeSlashIcon: OutlineEyeSlashIcon,
    GlobeAltIcon: OutlineGlobeAltIcon,
    HandRaisedIcon: OutlineHandRaisedIcon,
    HomeIcon: OutlineHomeIcon,
    InboxIcon: OutlineInboxIcon,
    InboxStackIcon: OutlineInboxStackIcon,
    InformationCircleIcon: OutlineInformationCircleIcon,
    LightBulbIcon: OutlineLightBulbIcon,
    LockClosedIcon: OutlineLockClosedIcon,
    MapPinIcon: OutlineMapPinIcon,
    NewspaperIcon: OutlineNewspaperIcon,
    PaperAirplaneIcon: OutlinePaperAirplaneIcon,
    PhoneIcon: OutlinePhoneIcon,
    PlayIcon: OutlinePlayIcon,
    PlusCircleIcon: OutlinePlusCircleIcon,
    PresentationChartLineIcon: OutlinePresentationChartLineIcon,
    PuzzlePieceIcon: OutlinePuzzlePieceIcon,
    QuestionMarkCircleIcon,
    RocketLaunchIcon: OutlineRocketLaunchIcon,
    ServerIcon: OutlineServerIcon,
    ShieldCheckIcon: OutlineShieldCheckIcon,
    SparklesIcon: OutlineSparklesIcon,
    StarIcon: OutlineStarIcon,
    TrophyIcon: OutlineTrophyIcon,
    UserCircleIcon: OutlineUserCircleIcon,
    UserGroupIcon: OutlineUserGroupIcon,
    UserIcon: OutlineUserIcon,
    UsersIcon: OutlineUsersIcon,
    WrenchScrewdriverIcon: OutlineWrenchScrewdriverIcon,
    XCircleIcon: OutlineXCircleIcon,
    XMarkIcon: OutlineXMarkIcon,
};

const solidIcons: Record<string, HeroIcon> = {
    AcademicCapIcon: SolidAcademicCapIcon,
    ArrowDownTrayIcon: SolidArrowDownTrayIcon,
    ArrowLeftIcon: SolidArrowLeftIcon,
    ArrowPathIcon: SolidArrowPathIcon,
    ArrowRightIcon: SolidArrowRightIcon,
    ArrowTrendingDownIcon: SolidArrowTrendingDownIcon,
    ArrowTrendingUpIcon: SolidArrowTrendingUpIcon,
    BanknotesIcon: SolidBanknotesIcon,
    Bars3Icon: SolidBars3Icon,
    BeakerIcon: SolidBeakerIcon,
    BriefcaseIcon: SolidBriefcaseIcon,
    CalculatorIcon: SolidCalculatorIcon,
    CalendarIcon: SolidCalendarIcon,
    ChartBarIcon: SolidChartBarIcon,
    ChatBubbleLeftEllipsisIcon: SolidChatBubbleLeftEllipsisIcon,
    ChatBubbleLeftRightIcon: SolidChatBubbleLeftRightIcon,
    CheckBadgeIcon: SolidCheckBadgeIcon,
    CheckCircleIcon: SolidCheckCircleIcon,
    CheckIcon: SolidCheckIcon,
    ChevronDownIcon: SolidChevronDownIcon,
    ChevronRightIcon: SolidChevronRightIcon,
    ChevronUpIcon: SolidChevronUpIcon,
    ClockIcon: SolidClockIcon,
    CodeBracketIcon: SolidCodeBracketIcon,
    Cog6ToothIcon: SolidCog6ToothIcon,
    CpuChipIcon: SolidCpuChipIcon,
    CurrencyDollarIcon: SolidCurrencyDollarIcon,
    DocumentCheckIcon: SolidDocumentCheckIcon,
    DocumentTextIcon: SolidDocumentTextIcon,
    EnvelopeIcon: SolidEnvelopeIcon,
    ExclamationCircleIcon: SolidExclamationCircleIcon,
    ExclamationTriangleIcon: SolidExclamationTriangleIcon,
    EyeIcon: SolidEyeIcon,
    EyeSlashIcon: SolidEyeSlashIcon,
    GlobeAltIcon: SolidGlobeAltIcon,
    HandRaisedIcon: SolidHandRaisedIcon,
    HomeIcon: SolidHomeIcon,
    InboxIcon: SolidInboxIcon,
    InboxStackIcon: SolidInboxStackIcon,
    InformationCircleIcon: SolidInformationCircleIcon,
    LightBulbIcon: SolidLightBulbIcon,
    LockClosedIcon: SolidLockClosedIcon,
    MapPinIcon: SolidMapPinIcon,
    NewspaperIcon: SolidNewspaperIcon,
    PaperAirplaneIcon: SolidPaperAirplaneIcon,
    PhoneIcon: SolidPhoneIcon,
    PlayIcon: SolidPlayIcon,
    PlusCircleIcon: SolidPlusCircleIcon,
    PresentationChartLineIcon: SolidPresentationChartLineIcon,
    PuzzlePieceIcon: SolidPuzzlePieceIcon,
    QuestionMarkCircleIcon,
    RocketLaunchIcon: SolidRocketLaunchIcon,
    ServerIcon: SolidServerIcon,
    ShieldCheckIcon: SolidShieldCheckIcon,
    SparklesIcon: SolidSparklesIcon,
    StarIcon: SolidStarIcon,
    TrophyIcon: SolidTrophyIcon,
    UserCircleIcon: SolidUserCircleIcon,
    UserGroupIcon: SolidUserGroupIcon,
    UserIcon: SolidUserIcon,
    UsersIcon: SolidUsersIcon,
    WrenchScrewdriverIcon: SolidWrenchScrewdriverIcon,
    XCircleIcon: SolidXCircleIcon,
    XMarkIcon: SolidXMarkIcon,
};

function Icon({
    name,
    variant = 'outline',
    size = 24,
    className = '',
    onClick,
    disabled = false,
    ...props
}: IconProps) {
    const iconSet = variant === 'solid' ? solidIcons : outlineIcons;
    const IconComponent = iconSet[name] || QuestionMarkCircleIcon;

    return (
        <IconComponent
            width={size}
            height={size}
            className={`${!iconSet[name] ? 'text-gray-400' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
            onClick={disabled ? undefined : onClick}
            {...props}
        />
    );
}

export default Icon;
